/**
 * ArchMind logo assets — vector masters in public/brand/logos/, generated by
 * scripts/brand/generate_brand_svgs.py (wordmark outlined from Manrope, so the files render
 * identically everywhere, including inside <img>). Raster derivatives (favicons, app icons,
 * social images) come from scripts/brand/rasterize.js.
 *
 * If a variant is ever missing from this registry, BrandLogo falls back to the brand name as
 * accessible text in the approved hierarchy — never an improvised mark.
 */
export type LogoVariant = 'horizontal' | 'stacked' | 'symbol'
/**
 * color   = full colour, for light backgrounds
 * reverse = full-colour symbol + white wordmark, for dark (navy) backgrounds
 * white   = monochrome white, for dark or photographic backgrounds
 * dark    = monochrome navy, for light backgrounds where colour is not available
 */
export type LogoTone = 'color' | 'reverse' | 'white' | 'dark'

const VARIANTS: LogoVariant[] = ['horizontal', 'stacked', 'symbol']
const TONES: LogoTone[] = ['color', 'reverse', 'white', 'dark']

export const BRAND_LOGO_ASSETS: Partial<Record<`${LogoVariant}-${LogoTone}`, string>> = Object.fromEntries(
  VARIANTS.flatMap((variant) => TONES.map((tone) => [`${variant}-${tone}`, `/brand/logos/archmind-${variant}-${tone}.svg`])),
)

export const BRAND_NAME = 'ArchMind'
export const BRAND_DESCRIPTOR = 'WORKS'
/** Legal / company identity — use where the legal name is required (copyright, legal pages). */
export const BRAND_LEGAL_NAME = 'ArchMindWorks'

export function logoAsset(variant: LogoVariant, tone: LogoTone): string | undefined {
  return BRAND_LOGO_ASSETS[`${variant}-${tone}`]
}
